import React, {Suspense, useEffect, useState} from "react";
import TanstackQueryManager from "../managers/tanstack-query";
import {BrowserRouter, withRouter} from "react-router-dom";
import {v4 as uuid} from "uuid";
import ZendeskWidget from "../zendesk/ZendeskWidget";
import {getPageQuery, getPageQueryResult, PageProvider} from "../logic/page";

import {LoaderProvider} from "../logic/loader";

import Loader from "../sublayouts/components/loader";
import {LoaderManager} from "../managers/loader";

import config from "../config";
import F404 from "./404";
// import LoginForm from "../sublayouts/auth/login";
import LoginIndexForm from "../sublayouts/auth/index";
import {useTranslation} from "react-i18next";
import CleanGqlProvider from "../managers/clean-gql";
import {useQuery} from "../managers/clean-gql";
import {getSiteInfoQuery} from "../logic/user";

// LoginForm.hook = false; //so treeshake doesnt remove them
LoginIndexForm.hook = false;//so treeshake doesnt remove them


function Page(props) {
  const [, setLoaderState] = useState({
    components: [],
    loading: false,
  });
  const [resolvedPath, setResolvedPath] = useState(null);
  const [resolvedPage, setResolvedPage] = useState(null);

  const {t} = useTranslation();
  const u = new URL(window.location.toString());
  const p = `${u.protocol}//${u.host}${props.location.pathname}`;
  const pageQuery = useQuery(getPageQuery, {
    variables: {uri: p},
  });
  const siteInfoQuery = useQuery(getSiteInfoQuery);
  const siteInfo = siteInfoQuery.data;
  const page = getPageQueryResult(pageQuery);
  const currentPath = props.location.pathname;

  useEffect(() => {
    if (!pageQuery.loading && !siteInfoQuery.loading && siteInfo) {
      setResolvedPath(currentPath);
      setResolvedPage(page || null);
    }
  }, [currentPath, page, siteInfo, pageQuery.loading, siteInfoQuery.loading]);

  const loading = (
    resolvedPath !== currentPath
    || !siteInfo
    || pageQuery.loading
    || siteInfoQuery.loading
  );
  const displayPage = loading ? resolvedPage : page;


  useEffect(() => {
    let title = `${(page || {}).displayName || ""} - ${t("application.title") || "Q2 Platform"}`;

    const isInfra = siteInfoQuery.data?.siteInfo?.code === "inf";
    if (!siteInfoQuery.loading && !isInfra) {
      title += `- ${t("application.organisationName") || "Superloop"}`;
    }
    document.title = title;
  }, [pageQuery.loading, siteInfoQuery.loading, pageQuery.data, siteInfoQuery.data]);


  function removeLoader(id) {
    setLoaderState((state, props) => {
      const newComponents = state.components.filter((i) => {
        return id !== i;
      });
      return {
        components: newComponents,
        loading: newComponents.length > 0,
      };
    });
  }
  function setLoader() {
    const id = uuid();
    setLoaderState((state, props) => {
      return {
        components: state.components.concat([id]),
        loading: true,
      };
    });
    return id;
  }
  if (pageQuery.error) {
    return `Error! PageQuery - ${pageQuery.error.message}`;
  } else if (siteInfoQuery.error) {
    return `Error! SiteInfoQuery - ${siteInfoQuery.error.message}`;
  }
  //console.debug("Rendering layout for page:", displayPage?.layout?.path, displayPage);
  return (<LoaderProvider value={{
    removeLoader,
    setLoader,
  }}>
    <div style={{
      visibility: undefined,
    }}>
      {(loading && !displayPage) ? <Loader /> : undefined}
      {(displayPage) ? (<PageProvider value={{page: displayPage}}>
        <Suspense fallback={<Loader />}>
          {React.createElement(config.layouts[displayPage.layout.path])}
        </Suspense>
      </PageProvider>) : ((!loading) ? (<F404/>) : undefined)}
    </div>
    <ZendeskWidget siteInfo={siteInfo} loadingSiteInfo={siteInfoQuery.loading} />
  </LoaderProvider>);
}


const PageRenderer = withRouter(Page);



export default function Main() {
  return (
    <CleanGqlProvider>
      <TanstackQueryManager>
        <BrowserRouter>
          <LoaderManager>
            <PageRenderer />
          </LoaderManager>
        </BrowserRouter>
      </TanstackQueryManager>
    </CleanGqlProvider>
  );
}
